import AntDesign from '@expo/vector-icons/AntDesign';
import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { useEffect, useState } from 'react';
import { Image, View } from 'react-native';

// styles
import styles from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';

export function ImageExercise({
  url,
  isCorrect,
  isCorrectSelected,
  onCorrect,
  onWrong,
  notClickable,
  noWhiteBackground,
}) {
  const iconSize = useResponsiveFontSize(3);

  const [clicked, setClicked] = useState(false);
  const [isGrey, setIsGrey] = useState(false);

  const Icon = isCorrect ? (
    <View style={[styles.iconContainer, styles.greenBg]}>
      <AntDesign
        style={styles.icon}
        name="like1"
        size={iconSize}
        color="#ffff"
      />
    </View>
  ) : (
    <View style={[styles.iconContainer, styles.redBg]}>
      <AntDesign
        style={styles.icon}
        name="dislike1"
        size={iconSize}
        color="#ffff"
      />
    </View>
  );

  const onPress = () => {
    if (notClickable) {
      return;
    }
    if (clicked || isCorrectSelected) {
      return;
    }
    setClicked(true);
    if (isCorrect) {
      onCorrect();
    } else {
      onWrong();
    }
  };

  useEffect(() => {
    if (isCorrectSelected) {
      setIsGrey(true);
    }
  }, [isCorrectSelected]);

  return (
    <PressableNeolexon
      onPressIn={onPress}
      style={[styles.container, !noWhiteBackground && styles.isWhite]}
      disabled={notClickable}
      testID={isCorrect ? 'correctImage' : 'wrongImage'}
    >
      {clicked ? (
        <View style={[styles.layout, !isCorrect && styles.greyBackground]}>
          {Icon}
        </View>
      ) : null}
      {isGrey && !clicked ? (
        <View style={[styles.layout, !isCorrect && styles.greyBackground]} />
      ) : null}
      <Image style={styles.img} source={{ uri: url }} resizeMode="contain" />
    </PressableNeolexon>
  );
}
